<template>
  <layout-popup>
    <template slot="header">
      {{ context.title }}
    </template>
    <template>
      <template v-for="item in argumentsLocal">
        <v-text-field
          v-if="!item.valueSet.length && !isBoolean(item.typeSpec)"
          :key="item.id"
          class="px-6"
          :placeholder="item.argument"
          :label="item.description"
          v-model="item.value"
          clearable
        ></v-text-field>
        <template v-else-if="!item.valueSet.length && isBoolean(item.typeSpec)">
          <v-select
            :key="item.id"
            :menu-props="{ bottom: true, offsetY: true }"
            :placeholder="item.argument"
            :label="item.description"
            v-model="item.value"
            item-value="id"
            item-text="name"
            :items="[
              { id: true, name: 'true' },
              { id: false, name: 'false' },
              { id: null, name: 'null' }
            ]"
            class="px-6"
          >
            <template v-slot:item="{ item }">
              <div :data-test-select-value="item.name">
                {{ item.name }}
              </div>
            </template>
          </v-select>
        </template>
        <v-select
          v-else
          :menu-props="{ bottom: true, offsetY: true }"
          :data-test="item.title"
          :key="item.id"
          :label="item.description"
          v-model="item.value"
          item-value="key"
          class="px-6"
          item-text="title"
          :items="item.valueSet"
        >
          <template v-slot:item="{ item: i }">
            <div :data-test-select-value="`${item.title}:${i.title}`">
              {{ i.title }}
            </div>
          </template>
        </v-select>
      </template>

      <div v-if="!argumentsLocal.length" class="ma-4">No arguments</div>
    </template>

    <template slot="footer">
      <v-spacer />

      <v-btn text @click="$emit('close')">Cancel</v-btn>
      <v-btn color="primary" text @click="saveHandler" :loading="loading">
        execute
      </v-btn>
    </template>
  </layout-popup>
</template>

<script>
import LayoutPopup from '@/layouts/LayoutPopup';
import { isBoolean } from '@/utils/getCurrentType';

export default {
  name: 'ExecuteMethod',
  components: {
    LayoutPopup
  },
  data() {
    return {
      argumentsLocal: [],
      argumentsLocalObj: {}
    };
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    methodName: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isBoolean,
    saveHandler() {
      this.context.arguments.forEach(item => {
        this.argumentsLocalObj[item.argument] = item.value || '';
      });
      const params = {};
      this.argumentsLocal.forEach(item => {
        params[item.argument] = item.value;
      });

      this.$emit('save', {
        name: this.context.raw.argument,
        params
      });
    }
  },
  mounted() {
    this.context.arguments.forEach(item => {
      this.argumentsLocal.push({
        argument: item.argument,
        description: item?.units
          ? `${item.description}, ${item?.units}`
          : item.description,
        id: item.id,
        value: item?.value || null,
        typeSpec: item?.typeSpec,
        valueSet: item.valueSet
          ? Object.entries(item.valueSet).map(item => ({
              title: item[1],
              key: item[0]
            }))
          : []
      });
      // this.argumentsLocalObj[item.argument] = item.value || '';
    });
  }
};
</script>
